<template>
  <div class="modal--loading z-full-page-loading u-center bg-black-70 w-full h-full top-0 left-0 fixed">
    <OIcon icon="o-logo" class="loading-icon" aria-hidden="true" svg-class="w-12 h-12 text-white" />
    <div class="sr-only">{{ $t('main.progress') }}</div>
  </div>
</template>
<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { useLockScroll } from 'vue-composable';
import { OIcon } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OIcon },
  setup() {
    // Custom modal oldugu icin manual handle edildi diger modallar icin gerek yok OModal component'i bunu yapiyor
    useLockScroll('body');
  },
});
</script>
<style lang="scss" scoped>
.modal--loading {
  .loading-icon {
    animation: loading 2s infinite;
    opacity: 1;
  }
  @keyframes loading {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.2;
      transform: scale(0.8);
    }
    100% {
      opacity: 1;
    }
  }
}
</style>
